import React, { useState } from "react";
import ExpandedModal from "Samarth Module/components/modal/ExpandedModal";
import ArrowsOut from './../../../../assets/images/ArrowsOut.svg';
import styles from './POPriority.module.css';
import HorizontalMultiBarSimpleChart from "Samarth Module/components/Charts/HorizontalMultiBarSimpleChart";
import ToggleButton from "Samarth Module/components/ToggleButton/ToggleButton";

const POWisePriority = ({ label, customerData, dcData = []}) => {
    const [expandedView, setExpandedView] = useState(false);
    const [selectedView, setSelectedView] = useState('Customer Wise');
    // Handler for expanding the graph
    const handleExpand = () => {
        setExpandedView(prev => !prev);
    };

    const handleViewChange = (selected) => {
        setSelectedView(selected);
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p className={styles.title}>{label}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <ToggleButton
                        options={['Customer Wise', 'DC Wise']}
                        defaultSelected={selectedView}
                        onChange={handleViewChange}
                    />
                    <div className={styles.arrows_out}>
                        <img src={ArrowsOut} alt='Horizontal Stacked Bar Chart' height={16} width={16} onClick={handleExpand} />
                    </div>
                </div>
            </div>
            <HorizontalMultiBarSimpleChart graphData={selectedView === 'Customer Wise' ? customerData : dcData} view={selectedView} />
            {expandedView && (
                <ExpandedModal onClose={handleExpand} open={expandedView} >
                    <div className={styles.modalContainer}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <p className={styles.title}>{label}</p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <ToggleButton
                                    options={['Customer Wise', 'DC Wise']}
                                    defaultSelected={selectedView}
                                    onChange={handleViewChange}
                                />
                            </div>
                        </div>
                        <HorizontalMultiBarSimpleChart graphData={selectedView === 'Customer Wise' ? customerData : dcData} view={selectedView} />
                    </div>
                </ExpandedModal>
            )}
        </>
    );
};

export default POWisePriority;